export default __webpack_public_path__ + "static/kocaelispor-logo-fe0e6fef5ab5829a94319352c8854e08.png";